import styled from "styled-components";
import { flex, grid } from "../../mixins";

export const Wrapper = styled.section`
  width: var(--fluid-width);
  padding: 1rem;
  margin: 0 auto;
  ${grid()}
  grid-template-columns: repeat(2, 1fr);
`;

export const Section = styled.div`
  ${flex({ flexDirection: "row", justifyContent: "space-evenly" })}
  gap: 1rem;
  overflow: hidden;
`;
